import { Box, Icon, Tooltip } from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';
import { contactInfo } from '../lib/storage';

const WhatsAppButton: React.FC = () => {
  const handleClick = () => {
    const phoneNumber = contactInfo.whatsapp.replace(/\D/g, '');
    const message = encodeURIComponent('Olá! Gostaria de mais informações sobre os serviços jurídicos.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <Tooltip
      label="Fale conosco no WhatsApp"
      placement="left"
      hasArrow
      bg="yaleBlue"
      color="white"
      fontSize="sm"
      px={4}
      py={2}
      borderRadius="md"
    >
      <Box
        as="button"
        position="fixed"
        bottom={{ base: '24px', md: '32px' }}
        right={{ base: '24px', md: '32px' }}
        w={{ base: '56px', md: '64px' }}
        h={{ base: '56px', md: '64px' }}
        bg="#25D366"
        borderRadius="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
        boxShadow="0 4px 16px rgba(37, 211, 102, 0.4)"
        cursor="pointer"
        zIndex={999}
        transition="all 0.3s ease"
        onClick={handleClick}
        _hover={{
          transform: 'scale(1.1)',
          bg: '#20BA5A',
          boxShadow: '0 6px 24px rgba(37, 211, 102, 0.6)',
        }}
        _active={{
          transform: 'scale(0.95)',
        }}
        animation="pulse 2s infinite"
        aria-label="Fale conosco no WhatsApp"
      >
        <Icon
          as={FaWhatsapp}
          boxSize={{ base: '28px', md: '32px' }}
          color="white"
        />

        {/* Pulse animation */}
        <style>
          {`
            @keyframes pulse {
              0% {
                box-shadow: 0 4px 16px rgba(37, 211, 102, 0.4);
              }
              50% {
                box-shadow: 0 4px 24px rgba(37, 211, 102, 0.6);
              }
              100% {
                box-shadow: 0 4px 16px rgba(37, 211, 102, 0.4);
              }
            }
          `}
        </style>
      </Box>
    </Tooltip>
  );
};

export default WhatsAppButton;
